import { useUsersCurrentAccessesQuery } from '@/api/queries/users';
import ViewPermissionsGate from '@/utils/view-permissions-gate';
import { Grid } from '@mui/material';
import CreateRideForm, {
  CreateRideFormResult,
} from 'components/forms/RideFormFactory/CreateRideForm';
import { ModalBase } from 'remote/global';

type CreateRideModalFormProps = {
  open: boolean;
  onClose: () => void;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  defaultValues?: CreateRideFormResult;
  isCreateOfferVariant?: boolean;
};

function CreateRideModal({
  open,
  setOpen,
  onClose,
  isCreateOfferVariant,
  defaultValues = [],
}: CreateRideModalFormProps) {
  const { data: userInfo } = useUsersCurrentAccessesQuery();
  const { permissions = {} } = userInfo || {};

  return (
    <ModalBase
      open={open}
      setOpen={setOpen}
      onClose={onClose}
      maxWidth='md'
      scroll='body'
      fullWidth
      preventCloseOutside
      PaperProps={{
        sx: { overflow: 'unset' },
      }}
    >
      <Grid
        container
        sx={{
          p: '0 48px',
          justifyContent: 'center',
          alignItems: 'stretch',
          '& .MuiGrid-root': { maxWidth: 'inherit' },
        }}
      >
        <ViewPermissionsGate
          role={isCreateOfferVariant ? permissions.OPERATOR_OFFER : permissions.ORDER}
        >
          <CreateRideForm
            isCreateOfferVariant={isCreateOfferVariant}
            onClose={onClose}
            defaultValues={defaultValues}
          />
        </ViewPermissionsGate>
      </Grid>
    </ModalBase>
  );
}

export default CreateRideModal;
